import { Switch, Route } from "react-router-dom";


//views - user
import Main from '../viewsxz/main';
import Land from '../viewsxz/land';
import Search from '../viewsxz/search';

import Home from '../viewsaa/home';
import Courses from "../viewsaa/courses";
import Groups from "../viewsaa/rooms";
import RoomView from "../viewsaa/roomview";

import Vault from '../viewsav/vaultlist';
import DocsInfo from "../viewsav/docsinfo";
import DocsCheck from "../viewsav/docscheck";

import Settings from '../viewsaa/settings';

import AuthMailCode from '../viewsxa/auth-mail';
import SessionX from '../viewsxa/auth-session-x';

import HomeBz from '../viewsbz/home';
import CoursesBz from "../viewsbz/courses";
import TeamList from "../viewsbz/teamlist";
import TeamLink from "../viewsbz/teamlink";
import TeamEdit from "../viewsbz/teamedit";
import TeamInfo from "../viewsbz/teaminfo";
import TeamSearch from "../viewsbz/teamsrch";
import RoomsBz from "../viewsbz/rooms";

const routes =[

  { path:'/home', component: Home, auth:true },
  { path:'/courses', component: Courses, auth:true },
  { path:'/groups', component: Groups, auth:true },
  { path:'/room/:id', component: RoomView, auth:true },
  { path:'/vault', component: Vault, auth:true },
  { path:'/vault/view/:id', component: DocsInfo, auth:true },
  { path:'/vault/check', component: DocsCheck, auth:true },
  { path:'/settings', component: Settings, auth:true },

  { path:'/bz/home', component: HomeBz, auth:true },
  { path:'/bz/courses', component: CoursesBz, auth:true },
  { path:'/bz/team', component: TeamList, auth:true },
  { path:'/bz/team/link', component: TeamLink, auth:true },
  { path:'/bz/team/view/:id', component: TeamInfo, auth:true },
  { path:'/bz/team/edit/:id', component: TeamEdit, auth:true },
  { path:'/bz/team/search', component: TeamSearch, auth:true },
  { path:'/bz/groups', component: RoomsBz, auth:true },
  { path:'/bz/settings', component: Settings, auth:true },

  { path:'/', component: Land, auth:false },
  { path:'/search', component: Search, auth:false },
  { path:'/auth', component: AuthMailCode, auth:false },
  { path:'/sessionx', component: SessionX, auth:false },
  
]

export default function Routes() {

  return (
    <Switch>
      {routes.map ((item,i)=>(
        <Route
          key={i}
          path={item.path}
          component={item.component}
          exact
        />
      ))}
    </Switch>
  );
}